import styled from "styled-components";
const FontSize="10px";
export const MainDiv=styled.div`
    width: 100%;
`
export const Table=styled.table`
    border: solid 1px black;
`
export const Thead=styled.thead`
    position: sticky;
    top: 0px;
    background: white;
`
export const Th=styled.th`
    position: sticky;
    border: solid 1px black;
    font-size: ${FontSize};

`
export const Tr=styled.tr`
    border: solid 1px black;
    font-size: ${FontSize};
`
export const Td=styled.td`
    border: solid 1px black;
  
`
export const PercentText=styled.text`    
    color:  red;
`
export const TdGradient=styled.td`
    text-align: center;
    background: linear-gradient(
            to top,
            lightgreen 0%,
            lightgreen ${props=>props.value==100?props.value:props.value-10}%,            
            red ${props=>props.value+10}%,
            red 100%
    );
`
export const HouseSelectionDiv=styled.div`
    margin-left: auto;
    margin-right: auto;
    margin-top: 20px;
    margin-bottom: 20px;
    width: 90%;
    display: grid;
    grid-template-columns:repeat(7, auto);
    gap: 5px;
    border: black 1px solid;
    pointer-events: ${props=>props.clickable};
    display: ${props=>props.visible};
`
export  const LineDiv=styled.div`
    display: flex;
`